/**
* @Author: Matthias Gohla <Matze>
* @Date:   2016-09-21T09:42:02+02:00
* @Email:  matze_lebt@gmx.de
* @Last modified by:   Matze
* @Last modified time: 2016-09-21T09:46:20+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';


/**
 * ALinkFooter - …
**/
class ALinkFooter extends Component {
  /**
     * TODO jsdoc
     *
     * @return {object}
     */
  render() {
    const {
      label,
      href,
      onPress,
      active,
      target,
    } = this.props;
    const activeClass = (active) ? 'active' : '';
    return (
      <a
        className={`a-link a-link-footer ${activeClass}`}
        href={href}
        onClick={onPress}
        target={target || null}
      >{label}</a>
    );
  }
}

ALinkFooter.propTypes = {
  label: PropTypes.string.isRequired,
  onPress: PropTypes.func,
  href: PropTypes.string,
  target: PropTypes.string,
  active: PropTypes.bool,
};
ALinkFooter.defaultProps = {
  active: false,
};
export default ALinkFooter;

